<template>
    <div id="Events">
        <mobileHeader v-if="isMobile == 'Mobile'" touterNum=3></mobileHeader>
        <Header v-else></Header>
        <backhead :title="titleLabel"></backhead>
        <div class="mainbox app-content" :class="{ Mobileclass: isMobile == 'Mobile' }">
            <!-- <h3 class="app-title">{{ h3Intro }}</h3> -->
            <div class="hasline">
                <!-- <p>{{ dec }}</p> -->
                <div class="list ">
                    <div class="box" v-for="(item, index) in arrList" :key="index"  @click="todetails(item.id)">
                        <img :src="item.image" alt="" class="pic">
                        <div class="con">
                        <p class="tit app-title">{{item.title}}</p>
                         <p class="tim">{{ item.start_time }} {{item.start_time? '-':"" }} {{ item.end_time }}</p>
                        </div>
                        
                    </div>
                    <div class="box" v-if="arrList.length % 4 > 1"></div>
                    <div class="box" v-if="arrList.length % 4 == 2"></div>
                </div>
            </div>
            <!-- <h3 class="app-title">{{ h3Recommend }}</h3> -->
            <!-- <div class="hasline" v-for="(item, index) in arrList" :key="index"> -->
                <!-- <div class="imgtxt">
                    <img :src="item.image" alt="" class="pic" v-show="index % 2 == 0">
                    <div>
                        <h5 class="app-title">{{item.title}}</h5>
                        <p v-html="item.content"></p>
                    </div>
                    <img :src="item.image" alt="" class="pic" v-show="index % 2 != 0">
                </div> -->
            <!-- </div> -->
        </div>
    </div>
</template>

<script setup>
    import { ref, watch, computed } from 'vue';
    import { getshowList } from "../utils/gerData";
    import { currentLanguage } from "../utils/lang";
    import { backheadTitles, pageLabels,imageurl } from "../utils/i18nLabels";
    import router from '@/router';
    const isMobile = localStorage.getItem('userAgent')

    const arrList = ref([]);
    const titleLabel = computed(() => backheadTitles.events[currentLanguage.value || 'zh'])
    const h3Intro = computed(() => pageLabels.events.intro[currentLanguage.value || 'zh'])
    const h3Recommend = computed(() => pageLabels.events.service[currentLanguage.value || 'zh'])
    const dec = computed(() => pageLabels.events.dec[currentLanguage.value || 'zh'])

    function todetails(id) {
        router.push("/details?pid=1&id=" + id)
    } 
    // 获取列表数据
    function getList() {
        let queryParams = {
            page: 1,
            pageSize: 100,
            pid: 8
        }
        getshowList(queryParams).then(res => {
            const data = res.data
            data.list.map(item => {
                 item.start_time =item.start_time!='0001-01-01T00:00:00Z'? item.start_time.slice(0, 10).replace(/-/g, "."):"";
                item.end_time = item.end_time!='0001-01-01T00:00:00Z'?item.end_time.slice(0, 10).replace(/-/g, "."):"";
                item.image = item.image ? imageurl + item.image : undefined
            })
            arrList.value = data.list;
        });
    }
    getList()

    watch(currentLanguage, () => {
        getList()
    })
</script>

<style scoped>
    #Events{
        overflow: hidden;
    }
    .mainbox{
        margin-top: 200px;
        /* text-align: left; */
    }
    .hasline{
        /* border-bottom: 2px solid #f0f0f0; */
        overflow: hidden;
        /* padding: 60px; */
    }
    h3{
        font-size: 39px;
        color: #232323;
        font-weight: normal;
        padding: 60px 60px 0;
    }
    .list{
         /* max-width: 814px; */
            margin: 0 auto;

        /* flex-wrap: wrap; */
        /* margin: 80px 0 40px 0; */
        .box{
            width: 100%;
            .pic{
                width: 100%;
                /* height: 200px; */
                object-fit: cover;
                display: block;
            }
            .tit{
                font-size: 25px;
                color: #000;
                margin: 10px 0;
            }
        }
    }
    .imgtxt{
          /* max-width: 814px; */
          width: 100%;
            margin: 0 auto;
        /* align-items: flex-start; */
        img{
            width: 100%;
        }
        div{
            width: 100%;
        }
        h5{
            font-size: 28px;
            color: #000;
            margin-bottom: 20px;
        }
        p{
            color: #3f3f3f;
            font-size: 24px;
        }
    }
    /* 二次改版样式调整 */
     .list {
        .box {      
            .pic {
                width: 100%;
                height: 550px;
            }
            .con {
                padding: 40px 40px 16px 40px; 
                text-align: left;
            }
            .tit {
                 /* padding: 40px 40px 16px 40px;  */
                 /* text-align: left; */
            }
        }
    }

    .Mobileclass{
        margin-top: 160px;
        h3{
            font-size: 34px;
            padding: 0 22px;
        }
        .hasline{
            padding: 22px;
            border: none;
            .imgtxt {
                display: block;
                img{
                    width: 100%;
                    display: block;
                    margin: 10px 0;
                }
                div{
                    width: 100%;
                }
                h5{
                    font-size: 28px;
                    margin: 20px 0;
                }
            }
        }
        .list{
            display: block;
            margin: 20px 0 40px 0;
        }
        .box{
            width: 100%;
            .tit{
                font-size: 30px;
                margin: 10px 0 50px 0;
            }

              /* 二次改版移动端改动 */
            .pic {
                height: 288px;
            }
            .con{
                padding: 20px 16px 16px 16px; 
            }
        }
    }
</style>